import FormSelect from '../FormSelect';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { css } from '@linaria/core';
import { trackFilterSelection } from '../../utils/dataLayer';

const optionCount = css`
  border-radius: 5px;
  padding: 3px 5px;
  font-size: 16px;
  background: #d1e1fb;
  color: #1a1a1a;
  margin-left: 10px;
`;

const optionBase = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export default function MultiSelectDropDownFilter(props) {
  const { fieldId, filters } = props;
  const [fieldData, setFieldData] = useState([]);
  const prevFieldData = useRef([]);
  const facets = props.facets;

  let options =
    facets[fieldId] && facets[fieldId].length > 0
      ? facets[fieldId][0].data
      : [];

  useEffect(() => {
    const existingFilters = filters?.find(filter => filter.field === fieldId);
    if (existingFilters?.values) {
      setFieldData(
        existingFilters.values.map(filter => ({
          label: filter,
          value: filter,
        })),
      );
    } else {
      setFieldData([]);
    }
  }, [filters]);

  useEffect(() => {
    prevFieldData.current = fieldData;
  }, [fieldData]);

  const selectLabel = option => (option.name ? option.name : option.value);

  const filterBySearchLabel = (option, inputValue) =>
    option.data.searchLabel.toLowerCase().includes(inputValue.toLowerCase());

  const processedOptions = useMemo(
    () =>
      options.map(option => ({
        label: (
          <span className={`${optionBase}`}>
            <span>{selectLabel(option)}</span>
            <span className={optionCount}>{option.count.toLocaleString()}</span>
          </span>
        ),
        value: option.value,
        searchLabel: selectLabel(option),
      })),
    [options],
  );

  const handleFieldData = selectedOptions => {
    selectedOptions
      .filter(
        option =>
          !prevFieldData.current.some(prev => prev.value === option.value),
      )
      .forEach(option => {
        trackFilterSelection(fieldId, option.value);
        props.addFilter(fieldId, option.value, 'any');
      });

    prevFieldData.current
      .filter(
        prev => !selectedOptions.some(option => option.value === prev.value),
      )
      .forEach(option => {
        props.removeFilter(fieldId, option.value);
      });
  };

  const handleSelect = selectedOptions => {
    const data = selectedOptions ?? [];
    setFieldData(data);
    handleFieldData(data);
  };

  return (
    <FormSelect
      isMulti
      disabled={options.length === 0}
      filterOption={filterBySearchLabel}
      formHint={props.formHint}
      id={props.id}
      label={props.label}
      onChange={handleSelect}
      options={processedOptions}
      value={fieldData}
    />
  );
}
